class AnimationStore {
    constructor() {
        // Animation timeline
        this.times = [];
        
        // Gengivas animation state
        this.gengivas = { maxi: {}, mandi: {} };
        this.gengivasComparative = { maxi: {}, mandi: {} };
        this.gengivasMaloc = { maxi: {}, mandi: {} };
        this.gengivasSetup = { maxi: {}, mandi: {} };
        this.maxGengivaKey = { maxi: 0, mandi: 0 };
        
        // Pontics animation state
        this.pontics = {};
        
        // Animation control
        this.archMatrix = {
            U: 'maxi',
            L: 'mandi'
        };
    }

    // Times management
    setTimes(timesArray) {
        this.times = timesArray;
    }

    getTimes() {
        return this.times;
    }

    addTime(time) {
        if (this.times.indexOf(time) === -1) {
            this.times.push(time);
            this.times.sort((a, b) => a - b);
        }
    }

    // Gengivas management
    setGengivas(gengivasObj) {
        this.gengivas = gengivasObj;
    }

    getGengivas() {
        return this.gengivas;
    }

    getGengiva(position, key) {
        return this.gengivas[position]?.[key];
    }

    addGengiva(gengiva, position, key) {
        if (!this.gengivas[position]) {
            this.gengivas[position] = {};
        }
        this.gengivas[position][key] = gengiva;
        this.updateMaxGengivaKey(position);
    }

    updateMaxGengivaKey(position) {
        if (!this.gengivas[position] || Object.keys(this.gengivas[position]).length === 0) {
            this.maxGengivaKey[position] = 0;
            return;
        }
        
        this.maxGengivaKey[position] = Object.keys(this.gengivas[position]).reduce((a, b) => 
            this.gengivas[position][a] > this.gengivas[position][b] ? a : b
        );
    }

    getMaxGengivaKey(position) {
        return this.maxGengivaKey[position];
    }

    // Gengivas comparative management
    setGengivasComparative(comparativeObj) {
        this.gengivasComparative = comparativeObj;
    }

    getGengivasComparative() {
        return this.gengivasComparative;
    }

    setGengivasMaloc(malocObj) {
        this.gengivasMaloc = malocObj;
    }

    getGengivasMaloc() {
        return this.gengivasMaloc;
    }

    setGengivasSetup(setupObj) {
        this.gengivasSetup = setupObj;
    }

    getGengivasSetup() {
        return this.gengivasSetup;
    }

    // Pontics management
    setPontics(ponticsObj) {
        this.pontics = ponticsObj;
    }

    getPontics() {
        return this.pontics;
    }

    getPontic(position, key) {
        return this.pontics[position]?.[key];
    }

    addPontic(pontic, position, key) {
        if (!this.pontics[position]) {
            this.pontics[position] = {};
        }
        this.pontics[position][key] = pontic;
    }

    // Arch matrix
    getArchMatrix() {
        return this.archMatrix;
    }

    getPositionFromArch(arch) {
        return this.archMatrix[arch];
    }

    dispose() {
        this.times = [];
        
        const disposeGengivas = (gengivas) => {
            Object.values(gengivas).forEach(positionGengivas => {
                Object.values(positionGengivas).forEach(mesh => {
                    if (mesh.geometry) mesh.geometry.dispose();
                    if (mesh.material) {
                        if (Array.isArray(mesh.material)) {
                            mesh.material.forEach(m => m.dispose());
                        } else {
                            mesh.material.dispose();
                        }
                    }
                });
            });
        };
        
        disposeGengivas(this.gengivas);
        disposeGengivas(this.gengivasComparative);
        disposeGengivas(this.gengivasMaloc);
        disposeGengivas(this.gengivasSetup);
        
        this.gengivas = { maxi: {}, mandi: {} };
        this.gengivasComparative = { maxi: {}, mandi: {} };
        this.gengivasMaloc = { maxi: {}, mandi: {} };
        this.gengivasSetup = { maxi: {}, mandi: {} };
        
        Object.values(this.pontics).forEach(positionPontics => {
            Object.values(positionPontics).forEach(mesh => {
                if (mesh.geometry) mesh.geometry.dispose();
                if (mesh.material) {
                    if (Array.isArray(mesh.material)) {
                        mesh.material.forEach(m => m.dispose());
                    } else {
                        mesh.material.dispose();
                    }
                }
            });
        });
        this.pontics = {};
    }
}

export const animationStore = new AnimationStore();
export { AnimationStore };